import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import Field from './fields/Field';

import messages from './messages';
import isHidden from './metadataUtil';
import './TemplatedInstance.scss';

var TemplatedInstance = function TemplatedInstance(_ref) {
    var canEdit = _ref.canEdit,
        _ref$data = _ref.data,
        data = _ref$data === undefined ? {} : _ref$data,
        errors = _ref.errors,
        onFieldChange = _ref.onFieldChange,
        onFieldRemove = _ref.onFieldRemove,
        template = _ref.template;
    var _template$fields = template.fields,
        fields = _template$fields === undefined ? [] : _template$fields;

    var hasFields = fields.length > 0;
    var hasVisibleFields = hasFields && fields.some(function (field) {
        return !isHidden(field);
    });
    var showNoFieldsMessage = !hasFields;
    var showHiddenFieldsMessage = hasFields && !hasVisibleFields;

    return React.createElement(
        React.Fragment,
        null,
        hasVisibleFields && fields.map(function (field) {
            return React.createElement(Field, {
                key: field.id,
                canEdit: canEdit,
                dataKey: field.key,
                dataValue: data[field.key],
                description: field.description,
                displayName: field.displayName,
                error: errors[field.key],
                isHidden: isHidden(field) // Checking both isHidden and hidden attributes due to differences in V2 and V3 APIs
                , onChange: function onChange(key, value) {
                    if (canEdit && onFieldChange) {
                        onFieldChange(key, value, field.type);
                    }
                },
                onRemove: function onRemove(key) {
                    if (canEdit && onFieldRemove) {
                        onFieldRemove(key);
                    }
                },
                options: field.options,
                type: field.type
            });
        }),
        showHiddenFieldsMessage && React.createElement(
            'div',
            { className: 'attributes-hidden-message' },
            React.createElement(FormattedMessage, messages.allAttributesAreHidden)
        ),
        showNoFieldsMessage && React.createElement(
            'div',
            { className: 'no-attributes-message' },
            React.createElement(FormattedMessage, messages.noAttributesForTemplate)
        )
    );
};

TemplatedInstance.propTypes = {
    canEdit: PropTypes.bool.isRequired,
    errors: PropTypes.shape({}).isRequired,
    onFieldChange: PropTypes.func,
    onFieldRemove: PropTypes.func,
    data: function data() {
        return (typeof bpfrpt_proptype_Fields === 'function' ? bpfrpt_proptype_Fields.isRequired ? bpfrpt_proptype_Fields.isRequired : bpfrpt_proptype_Fields : PropTypes.shape(bpfrpt_proptype_Fields).isRequired).apply(this, arguments);
    },
    template: function template() {
        return (typeof bpfrpt_proptype_Template === 'function' ? bpfrpt_proptype_Template.isRequired ? bpfrpt_proptype_Template.isRequired : bpfrpt_proptype_Template : PropTypes.shape(bpfrpt_proptype_Template).isRequired).apply(this, arguments);
    }
};
export default TemplatedInstance;
import { bpfrpt_proptype_Fields } from './flowTypes';
import { bpfrpt_proptype_FieldValue } from './flowTypes';
import { bpfrpt_proptype_Template } from './flowTypes';
import PropTypes from 'prop-types';